export function scrollDomController() {
    var domIdMap = {};
    var addItem = function (id, ref) {
        domIdMap[id] = ref;
    };
    var removeItem = function (id) {
        delete domIdMap[id];
    };
    var getItem = function (id) {
        return domIdMap[id];
    };
    var getFirstVisibleDom = function (err) {
        var firstNode;
        var firstTop;
        Object.keys(err).forEach(function (id) {
            var item = getItem(id) || {};
            var node = item.current;
            if (node) {
                var top_1 = node.getBoundingClientRect().top;
                if (firstTop === undefined || firstTop > top_1) {
                    firstTop = top_1;
                    firstNode = node;
                }
            }
        });
        return firstNode;
    };
    var scrollToDom = function (dom) {
        dom.scrollIntoView();
    };
    var scrollErrors = function (err) {
        var firstDom = getFirstVisibleDom(err);
        if (firstDom) {
            scrollToDom(firstDom);
        }
    };
    return {
        domIdMap: domIdMap,
        addItem: addItem,
        removeItem: removeItem,
        getItem: getItem,
        scrollErrors: scrollErrors,
    };
}
